/* eslint func-names: ["error", "never"] */

import mcqueenRegularFile from '/src/fonts/mcqueen/mcqueen-display-regular.woff2';
import mcqueenMediumFile from '/src/fonts/mcqueen/mcqueen-display-medium.woff2';

if ('fonts' in document) {
	let mcqueen = new FontFace('Mcqueen', `url(${mcqueenRegularFile})`);
	let mcqueenMedium = new FontFace('Mcqueen', `url(${mcqueenMediumFile})`, {
		weight: '600',
	});

	Promise.all([mcqueen.load(), mcqueenMedium.load()]).then(function () {
		document.documentElement.classList.add('fonts-loaded-1');
	});
}
